import request from "utils/request";

//首页lv推荐
function lawyerads(data) {
  return request({
    url: "/api/lawyerads",
    params: data
  });
}

// 法律领域
function knowledgecats(data) {
  return request({
    url: "/api/knowledgecats",
    params: data
  });
}

// 合同分类
function contractcats(data) {
  return request({
    url: "/api/contractcats",
    params: data
  });
}



// 合同分类
function contractlist(data) {
  return request({
    url: "/api/contractlist",
    params: data
  });
}

// 城市列表
function areas(data) {
  return request({
    url: "/api/areas",
    params: data
  });
}

//热门城市

function hotcitys(data) {
  return request({
    url: "/api/hotcitys",
    params: data
  });
}

//省市联动列表接口
function provincecity(data) {
  return request({
    url: "/api/provincecity",
    params: data
  });
}

// 法律知识
function newslist(data) {
  return request({
    url: "/api/newslist",
    params: data
  });
}

//解决方案分类
function solutioncats(data) {
  return request({
    url: "/api/solutioncats",
    params: data
  });
}

//排行榜
function lawyerrank(data) {
  return request({
    url: "/api/lawyerrank",
    params: data
  });
}

//热门类别
function majors(data) {
  return request({
    url: "/api/majors",
    params: data
  });
}

export default{
	lawyerads,
	knowledgecats,	
	contractcats,
	contractlist,
	areas,
	hotcitys,
	provincecity,
	newslist,
	solutioncats,
	lawyerrank,
	majors
}